import CheckRadioButton from '../../shared/components/forms/CheckRadioButton';

interface Props {
    label: string;
    name: string;
    value?: number | null | boolean;
    onChange: (name: string, value: string | number | boolean) => void;
}

export default function HasUserSelector({ label, name, value, onChange }: Props) {
    return (
        <>
            <label htmlFor=''>{label}</label>
            <div className='d-flex gap-4'>
                <CheckRadioButton
                    name={name}
                    label='Si'
                    onChange={(name, value) => onChange(name, value)}
                    checked={value === true}
                    value={true}
                    radioGroup={'hasUser'}
                    key='isUser'
                />
                <CheckRadioButton
                    name={name}
                    label='No'
                    onChange={(name, value) => onChange(name, value)}
                    checked={value === false}
                    value={false}
                    radioGroup={'hasUser'}
                    key='notUser'
                />
            </div>
        </>
    );
}
